const colors = {
	primary: {
		50: '#E8FBFD',
		100: '#D0F6FB',
		200: '#A2EEF6',
		300: '#6EE5F2',
		400: '#40DCED',
		500: '#15CFE4',
		600: '#11A6B6',
		700: '#0C7B87',
		800: '#09555D',
		900: '#042A2F',
		950: '#021517',
	},
	secondary: {
		50: '#F0F1FF',
		100: '#E0E3FF',
		200: '#C2C8FF',
		300: '#A3ACFF',
		400: '#8591FF',
		500: '#6675FF',
		600: '#1F35FF',
		700: '#0015D6',
		800: '#000E8F',
		900: '#000747',
		950: '#000424',
	},
	dark: {
		50: '#F2F2F4',
		100: '#E5E5E8',
		200: '#CCCCD2',
		300: '#9999A4',
		400: '#666677',
		500: '#4D4D60',
		600: '#38384E',
		700: '#26263E',
		800: '#1A1A33',
		900: '#0D0D27',
		950: '#00001C',
	},
	success: {
		50: '#ECFEF6',
		100: '#D9FCEE',
		200: '#B2FADC',
		300: '#87F7C9',
		400: '#61F5B7',
		500: '#3BF2A5',
		600: '#0FE189',
		700: '#0BA766',
		800: '#087346',
		900: '#043923',
		950: '#021D12',
	},
	warning: {
		50: '#FFFBEB',
		100: '#FFF6D6',
		200: '#FFECA9',
		300: '#FEE380',
		400: '#FED952',
		500: '#FECF2A',
		600: '#EAB701',
		700: '#B28B01',
		800: '#755C01',
		900: '#3D3000',
		950: '#1E1800',
	},
	danger: {
		50: '#FFF0F1',
		100: '#FFE5E7',
		200: '#FFC7CB',
		300: '#FFADB3',
		400: '#FF949B',
		500: '#FF7880',
		600: '#FF2E3C',
		700: '#E0000F',
		800: '#94000A',
		900: '#4D0005',
		950: '#240002',
	},
	blue: {
		50: '#D7D6FF',
		100: '#AFADFF',
		200: '#5F5CFF',
		300: '#0905FF',
		400: '#0300B3',
		500: '#020060',
		600: '#01004D',
		700: '#010038',
		800: '#010029',
		900: '#000014',
		950: '#00000A',
	},
	orchid: {
		50: '#FAEDFD',
		100: '#F4DBFB',
		200: '#E9B6F6',
		300: '#DF92F2',
		400: '#D46DED',
		500: '#C949E9',
		600: '#B41ADA',
		700: '#8714A4',
		800: '#5A0D6D',
		900: '#2D0737',
		950: '#16031B',
	},
	gold: {
		50: '#fbfbef',
		100: '#f0f2d3',
		200: '#e0e4a3',
		300: '#d2d673',
		400: '#ccca53',
		500: '#c5b848',
		600: '#ab9434',
		700: '#8f722e',
		800: '#755b2b',
		900: '#614b26',
		950: '#372811',
	},
	silver: {
		50: '#F7F7F7',
		100: '#EDEDED',
		200: '#DBDBDB',
		300: '#C9C9C9',
		400: '#B8B8B8',
		500: '#A6A6A6',
		600: '#858585',
		700: '#636363',
		800: '#424242',
		900: '#212121',
		950: '#121212',
	},
	bronze: {
		50: '#F9F3EB',
		100: '#F2E4D4',
		200: '#E6CBAD',
		300: '#D9B082',
		400: '#CD985B',
		500: '#B77C38',
		600: '#94642D',
		700: '#6D4A21',
		800: '#4A3217',
		900: '#23180B',
		950: '#140D06',
	},
};

type ColorsType = typeof colors;

export { colors, type ColorsType };
